import { Col, Divider, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react';

import SubHeader from '../../../components/SubHeader';
import { clientesPagadores } from '../../../helpers/clientesPagadores';
import { getRazaoSocial } from '../../../helpers/shipper';
import { useAuth } from '../../../security/authContext';
import { viagemReportService } from '../services/viagens-report-service';
import ViagemFilter from '../shared/Filters/ViagemFilter';
import { getColumns } from './columns';
import { Container } from './styles';

export default function RelatorioViagens() {
  const { user: userInfo } = useAuth();
  const [loading, setLoading] = useState(false);
  const [dataset, setDataset] = useState([]);
  const [pagination, setPagination] = useState({ current: 1 });
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({});
  const [clientes, setClientes] = useState(null);
  const [tableFilters, setTableFilters] = useState(null);

  const handleTableChange = (tbPagination, tbFilters, sorter) => {
    const tipo_lote = tbFilters.tipo_lote ? tbFilters.tipo_lote[0] : null;

    setTableFilters({
      sorter,
      ...(tipo_lote && { tipo_lote: tipo_lote.toUpperCase() }),
    });

    setPagination(tbPagination);
  };

  const handleAppliFilter = changeFilter => {
    setPagination({ current: 1 });
    setFilter({ ...filter, ...changeFilter });
  };

  const handleResetFilter = () => {
    setFilter({});
  };

  const columnsTable = getColumns();

  useEffect(() => {
    const onInit = async () => {
      const result = await clientesPagadores(userInfo.clientes_pagadores);
      setClientes(result);
    };

    onInit();
  }, []);

  useEffect(() => {
    async function loadViagens() {
      if (!clientes) return;

      setLoading(true);

      const { viagens, quantidade_registros } = await viagemReportService({
        filter: { ...tableFilters, ...filter },
        clientes,
        pagination,
      });

      setDataset(viagens);
      setTotal(quantidade_registros);
      setLoading(false);
    }

    loadViagens();
  }, [filter, tableFilters, pagination, clientes]);

  return (
    <>
      <SubHeader title={`RELATÓRIO DE VIAGENS - ${getRazaoSocial()}`} />
      <Container>
        <Col span={24}>
          {/** page filters */}
          <Row gutter={[8, 4]}>
            <Col span={24}>
              <ViagemFilter
                onReset={handleResetFilter}
                onConfirm={handleAppliFilter}
              />
            </Col>
          </Row>

          <Divider />

          <Row gutter={[8, 4]}>
            <Col span={24}>
              <Table
                onChange={handleTableChange}
                loading={loading}
                dataSource={dataset}
                columns={columnsTable}
                scroll={{ x: true }}
                pagination={{
                  total,
                  current: pagination.current,
                  position: ['bottomCenter'],
                }}
              />
            </Col>
          </Row>
        </Col>
      </Container>
    </>
  );
}
